import { Dropdown, Menu, MenuProps } from 'antd';
import React from 'react';
import { BiDotsVerticalRounded } from 'react-icons/bi';

type ItemKeys = 'edit' | 'updatePassword';

interface Items {
    key: ItemKeys;
    label: React.ReactNode;
    icon?: React.ReactNode;
}

type Props = {
    onEdit: () => void;
    onUpdatePassword: () => void;
};

const ActionMenu: React.FC<Props> = ({ onEdit, onUpdatePassword }) => {
    const headerMenuClick: MenuProps['onClick'] = (e) => {
        const key = e.key as ItemKeys;
        if (key === 'edit') {
            onEdit();
        }

        if (key === 'updatePassword') {
            onUpdatePassword();
        }
    };

    let items: Items[] = [
        {
            key: 'edit',
            label: 'Edit Details',
        },
        {
            key: 'updatePassword',
            label: 'Update Password',
        },
    ];

    const menu = <Menu className="border-0 header_menu" items={items} onClick={headerMenuClick} />;

    return (
        <div>
            <Dropdown placement="bottomRight" overlay={menu} trigger={['click']} overlayClassName="common_dropdown">
                <BiDotsVerticalRounded
                    size="1.4rem"
                    className="cursor-pointer ml-3"
                    onClick={(e) => e.preventDefault()}
                />
            </Dropdown>
        </div>
    );
};

export default ActionMenu;
